import React, { useState, useEffect } from "react";
import { Checkbox, Select, message, Button } from "antd";
import { useTranslation } from "react-i18next";
import { postRequest } from "../../../services/index";

const { Option } = Select;

const Step2 = (props) => {

    const { selectedSubLessons,selectChapter,selectedBookId, setDisplayBtn,randomQuestions, setRandomQuestions, setPaperInfo } = props;
    const [selectedQuestions, setSelectedQuestions] = useState([]);
    
    const [showGeneratedQuestions, setShowGeneratedQuestions] = useState(false);
    const [responceData, setResponceData] = useState([]);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    const [formData, setFormData] = useState({
        questionType: "question",
        examFrom: "",
        requiredQuestions: "",
        eachQuestionMarks: "",
        questionPerLine: 1,
        selectedDokLevels: "",
        randomSelectCount: "",
        class: "",
        subject: ""
    });

    const dokLevels = [
        { id: "1", name: t("DOKLevel1") },
        { id: "2", name: t("DOKLevel2") },
        { id: "3", name: t("DOKLevel3") },
        { id: "4", name: t("DOKLevel4") }
    ];

    useEffect(() => {
        if (randomQuestions.length > 0) {
            setDisplayBtn(true);
        }

        setSelectedQuestions(selectedSubLessons);
    }, [selectedSubLessons,randomQuestions]);

    const handleRandomQuestion = () => {
        const selectCount = parseInt(formData.randomSelectCount, 10) || parseInt(formData.requiredQuestions, 10);
        const randomIndexes = [];
        const questionsArray = formData.questionType === "question" 
            ? responceData.map(q => ({
                question: q.question,
                marks: q.marks
            }))
            : responceData.map(mcq => ({
                question: mcq.question,
                options: mcq.options,
                correctAnswer: mcq.correctAnswer,
                marks: mcq.marks
            }));
        
        while (randomIndexes.length < selectCount && randomIndexes.length < questionsArray.length) {
            const randomIndex = Math.floor(Math.random() * questionsArray.length);
            if (!randomIndexes.includes(randomIndex)) {
                randomIndexes.push(randomIndex);
            }
        }
        setRandomQuestions(randomIndexes.map(index => questionsArray[index]));
    };

    const handleQuestionClick = (question) => {
        if (formData.questionType === "question") {
            if (selectedQuestions.includes(question)) {
                setSelectedQuestions((prev) => prev.filter((q) => q !== question));
            } else {
                setSelectedQuestions((prev) => [...prev, question]);
            }
        } else {
            const questionObj = typeof question === 'object' ? question : { question };
            if (selectedQuestions.some(q => q.question === questionObj.question)) {
                setSelectedQuestions((prev) => prev.filter((q) => q.question !== questionObj.question));
            } else {
                setSelectedQuestions((prev) => [...prev, questionObj]);
            }
        }
    };

    const handleGeneratedQuestionClick = (question) => {
        const requiredQuestions = parseInt(formData.requiredQuestions, 10);
        if (formData.questionType === "question") {
            const questionObj = typeof question === 'object' ? question : { question, marks: formData.eachQuestionMarks };
            if (randomQuestions.some(q => q.question === questionObj.question)) {
                setRandomQuestions((prev) => prev.filter((q) => q.question !== questionObj.question));
            } else {
                if (randomQuestions.length >= requiredQuestions) {
                    message.error("Limit full. Please remove a question before adding a new one.");
                } else {
                    setRandomQuestions((prev) => [...prev, questionObj]);
                }
            }
        } else {
            const questionObj = typeof question === 'object' ? question : { question };
            if (randomQuestions.some(q => q.question === questionObj.question)) {
                setRandomQuestions((prev) => prev.filter((q) => q.question !== questionObj.question));
            } else {
                if (randomQuestions.length >= requiredQuestions) {
                    message.error("Limit full. Please remove a question before adding a new one.");
                } else {
                    setRandomQuestions((prev) => [...prev, questionObj]);
                }
            }
        }
    };

    const handleInputChange = (field, value) => {
        if (field === 'questionType') {
            // Reset data when question type changes
            setResponceData([]);
            setShowGeneratedQuestions(false);
            setRandomQuestions([]);
        }
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSubmit = async () => {
        
        setLoading(true);
        try {
            // Validate required fields
            if (!formData.requiredQuestions) {
                message.error('Please enter required questions');
                setLoading(false);
                return;
            }
            if (!formData.eachQuestionMarks) {
                message.error('Please enter marks per question');
                setLoading(false);
                return;
            }
            if (!formData.examFrom) {
                message.error('Please select exam type');
                setLoading(false);
                return;
            }
            if (!selectChapter) {
                message.error('Please select a chapter');
                setLoading(false);
                return;
            }
            if (!selectedSubLessons?.length) {
                message.error('Please select sub lessons');
                setLoading(false);
                return;
            }

            const payload = {
                bookId: selectedBookId,
                selectedChapters: selectChapter,
                selectedSubChapters: selectedSubLessons,
                questionType: formData.questionType,
                examFrom: formData.examFrom,
                requiredQuestions: parseInt(formData.requiredQuestions, 10),
                eachQuestionMarks: parseInt(formData.eachQuestionMarks, 10),
                questionPerLine: formData.questionPerLine,
                dokLevel: formData.selectedDokLevels,
                showGeneratedQuestions: showGeneratedQuestions
            };
            const Data = {
                questionType: formData.questionType,
                examFrom: formData.examFrom,
                eachQuestionMarks: parseInt(formData.eachQuestionMarks, 10),
                questionPerLine: formData.questionPerLine,
                dokLevel: formData.selectedDokLevels,
                class: formData.class,
                subject: formData.subject
            };
            setPaperInfo(Data)
            const response = await postRequest('/api/PaperGeneration/generate-questions', payload);
            if (response?.data) {
                setShowGeneratedQuestions(true);
                message.success('Questions generated successfully');
                setResponceData(response.data);
            }
        } catch (error) {
            message.error('Failed to generate questions',error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="exam-modal">
            <div className="question-list grid grid-cols-2 gap-4">
                {selectedSubLessons.map((question, index) => (
                    <div
                        key={index}
                        className="question-item flex items-center space-x-2"
                        onClick={() => handleQuestionClick(question)}
                    >
                        <Checkbox
                            checked={selectedQuestions.includes(question)}
                            onChange={() => handleQuestionClick(question)}
                        />
                        <span className="text-sm text-gray-700">{question}</span>
                    </div>
                ))}
            </div>
            <div className="input-fields mt-4 grid grid-cols-2 gap-4">
                <label className="flex flex-col text-sm text-gray-700">
                    {t("SelectQuestionType")}:
                    <Select 
                        className="mt-1" 
                        value={formData.questionType}
                        onChange={(value) => handleInputChange('questionType', value)}
                    >
                        <Option value="question">{t("Question")}</Option>
                        <Option value="MCQ">{t("MCQs")}</Option>
                    </Select>
                </label>
                <label className="flex flex-col text-sm text-gray-700">
                    {t("SelectExamFrom")}:
                    <Select 
                        className="mt-1" 
                        value={formData.examFrom}
                        onChange={(value) => handleInputChange('examFrom', value)}
                    >
                        <Option value="midterm">{t("Midterm")}</Option>
                        <Option value="final">{t("Final")}</Option>
                        <Option value="quiz">{t("Quiz")}</Option>
                    </Select>
                </label>
                <label className="flex flex-col text-sm text-gray-700">
                    {t("TotalQuestions")}:
                    <input 
                        type="number" 
                        min="1" 
                        className="mt-1 p-2 border rounded"
                        value={formData.requiredQuestions}
                        onChange={(e) => handleInputChange('requiredQuestions', e.target.value)}
                    />
                </label>
                <label className="flex flex-col text-sm text-gray-700">
                    {t("EachQuestionMarks")}:
                    <input 
                        type="number" 
                        min="1" 
                        className="mt-1 p-2 border rounded"
                        value={formData.eachQuestionMarks}
                        onChange={(e) => handleInputChange('eachQuestionMarks', e.target.value)}
                    />
                </label>
                <label className="flex flex-col text-sm text-gray-700">
                    {t("QuestionPerLine")}:
                    <Select 
                        className="mt-1" 
                        value={formData.questionPerLine}
                        onChange={(value) => handleInputChange('questionPerLine', value)}
                    >
                        <Option value={1}>1</Option>
                        <Option value={2}>2</Option>
                    </Select>
                </label>
                <label className="flex flex-col text-sm text-gray-700">
                    {t("DOKProfile")}:
                    <Select
                        className="mt-1"
                        value={formData.selectedDokLevels}
                        onChange={(value) => handleInputChange('selectedDokLevels', value)}
                    >
                        {dokLevels.map((level) => (
                            <Option key={level.id} value={level.id}>
                                {level.name}
                            </Option>
                        ))}
                    </Select>
                </label>
                <label className="flex flex-col text-sm text-gray-700">
                    {t("SelectNoOfQuestion")}:
                    <input 
                        type="number" 
                        min="1" 
                        className="mt-1 p-2 border rounded"
                        value={formData.randomSelectCount}
                        onChange={(e) => handleInputChange('randomSelectCount', e.target.value)}
                    />
                </label>
                <label className="flex flex-col text-sm text-gray-700">
                    {t("Class")}:
                    <input 
                        type="text" 
                        className="mt-1 p-2 border rounded"
                        value={formData.class}
                        onChange={(e) => handleInputChange('class', e.target.value)}
                    />
                </label>
                <label className="flex flex-col text-sm text-gray-700">
                    {t("Subject")}:
                    <input 
                        type="text" 
                        className="mt-1 p-2 border rounded"
                        value={formData.subject}
                        onChange={(e) => handleInputChange('subject', e.target.value)}
                    />
                </label>
            </div>
            <div className="flex justify-end mt-3">
                <Button onClick={handleSubmit} type="primary" loading={loading}>
                    {t("Submit")}
                </Button>
            </div>
            {showGeneratedQuestions && responceData && responceData.length > 0 && (
                <>
                <div className="button-group mt-4 flex space-x-4">
                    <Button onClick={handleRandomQuestion} type="primary">{t("SelectRandomQuestion")}</Button>
                </div>
                <div className="generated-questions mt-4">
                    <h5 className="text-lg font-bold text-gray-700">{t("GeneratedQuestions")}</h5>
                    <div>
                        {formData.questionType === "question" ? (
                            responceData.map((item, index) => (
                                <p
                                    key={index}
                                    className={`text-sm text-gray-700 ${randomQuestions.some(q => q.question === item.question) ? "bg-green-100" : ""}`}
                                    onClick={() => handleGeneratedQuestionClick(item.question)}
                                >
                                    {index + 1}. {item.question} ({t("Marks")}: {item.marks})
                                </p>
                            ))
                        ) : (
                            responceData.map((mcq, index) => (
                                <div key={index} className="mcq-item mb-2">
                                    <p
                                        className={`text-sm text-gray-700 ${randomQuestions.some(q => q.question === mcq.question) ? "bg-green-100" : ""}`}
                                        onClick={() => handleGeneratedQuestionClick(mcq)}
                                    >
                                        {index + 1}. {mcq.question} ({t("Marks")}: {mcq.marks})
                                    </p>
                                    <ul className="ml-4 flex flex-wrap">
                                        {mcq.options?.map((option, i) => (
                                            <li key={i} className={`text-sm text-gray-700 w-1/4 ${option === mcq.correctAnswer ? 'font-bold text-green-600' : ''}`}>
                                                {String.fromCharCode(65 + i)}. {option}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))
                        )}
                    </div>
                </div>
                
                </>
            )}

            {randomQuestions.length > 0 && (
                <div className="random-questions mt-4 p-2 bg-[#241763] rounded text-sm">
                    {randomQuestions.map((question, index) => (
                        <div key={index} className="mb-4">
                            <p className="text-md text-white mb-2">
                                {index + 1}. {typeof question === 'object' ? question.question : question}
                                {typeof question === 'object' && question.marks && (
                                    <span className="ml-2 text-green-400">({t("Marks")}: {question.marks})</span>
                                )}
                            </p>
                            {typeof question === 'object' && question.options && (
                                <ul className="ml-4">
                                    {question.options.map((option, i) => (
                                        <li key={i} className={`text-sm text-white ${option === question.correctAnswer ? 'font-bold text-green-400' : ''}`}>
                                            {String.fromCharCode(65 + i)}. {option}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Step2;